






























import Vue from "vue";
import Component from "vue-class-component";
import ApiFactory from "../../api/ApiFactory";
import {
  FindFactFindRequestByContactQuery,
  FactFindRequestDto
} from "@/api/ClientPortalApiClient";
import { RoleStore, UserStore } from "@/store";
import { FormatDate } from "@/filters/FormatDate";
import { Prop } from "vue-property-decorator";

@Component
export default class FactFindWidget extends Vue {
  @Prop() contactId: number | undefined;
  private factFindCompletedDate: string = "";
  factFindIsComplete: boolean = false;

  async created() {
    if (this.contactId == undefined && RoleStore.isClient) {
      this.contactId = UserStore.profileId;
    }
    if (RoleStore.isClient) {
      await this.isFactFindCompleted();
    }
  }

  async isFactFindCompleted() {
    const api = ApiFactory.CreateDataClient();
    const result = await api.factFindRequest_IsCompleted(
      this.contactId || this.profileId
    );
    this.factFindIsComplete = result ? result : false;

    if (this.factFindIsComplete) {
      await this.GetFactFindCompletedDate();
    }
  }

  private async GetFactFindCompletedDate() {
    const api = ApiFactory.CreateDataClient();
    const cmd = new FindFactFindRequestByContactQuery();
    cmd.contactId = UserStore.profileId;
    const result = await api.factFindRequest_RequestForContact(cmd);

    if (result) {
      const request: FactFindRequestDto = result;
      this.factFindCompletedDate = FormatDate.format(
        request.dateCreated,
        "DD/MM/YYYY"
      );
    }
  }

  get profileId(): number {
    return this.contactId || UserStore.profileId;
  }
}
